<template>
    <v-dialog v-model="dialog" width="500px">
        <v-card>
            <v-card-title class="warning headline" style="font-weight:bold; color:white">Confirm Delete</v-card-title>
            <v-card-text>Are you sure you want to remove {{hpbk.kstp_nr}} from the accommodation {{hpbk.huis_code}} ?</v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="warning mx-2" small @click="rmHpbk">Yes</v-btn>
                <v-btn color="success"  small @click="dialog = false">No</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

export default {
    data() { 
        return {
            dialog: false,
            hpbk_encrid: "",
            hpbk: {}
        }
    },
    methods: {
        open(hpbk_encrid) {
            this.dialog = true;
            this.hpbk_encrid = hpbk_encrid;
            this.$axios.post("ares/json/ares/huis/hspt/hpbk/getHpbk.p", {
                header: {
                    token: this.$session.get("ARES"),
                    clientSessionId: this.$session.id(),
                    request: "getHpbk"
                },
                getHpbk: {
                    hpbk_encrid: hpbk_encrid
                }
            }).then(res => {
                if (res.data.error) {
                    console.log(res.data.error);
                } else {
                    this.hpbk = res.data.getHpbk;
                }
            });
        },
        rmHpbk() { 
            this.$axios.post("ares/json/ares/huis/hspt/hpbk/rmHpbk.p", {
                header: {
                    token: this.$session.get("ARES"),
                    clientSessionId: this.$session.id(),
                    request: "rmHpbk"
                },
                rmHpbk: {
                    hpbk_encrid: this.hpbk.hpbk_encrid
                }
            }).then(res => {
                if (res.data.error) {
                    console.log(res.data.error);
                }  else { 
                    this.$store.dispatch('setSnackbar', {
                        showing: true,
                        text: res.data.rmHpbk.text,
                        color: res.data.rmHpbk.color
                    });
                    // Dit moet de encrid zijn zoals het aanroepende programma deze kent!!
                    this.$emit('updateData', this.hpbk_encrid);
                    this.dialog = false;
                }
            });
        },
    }
}
</script>
